import React from "react";
import "./OngoingProcess.css";

export default function OngoingProcess() {
  // Sample data for demonstration
  const processes = [
    {
      id: 1,
      vesselName: "MPV Atlantic Star",
      vesselType: "MPV 002",
      image: "https://res.cloudinary.com/du44pwjoi/image/upload/v1742471097/csv_klkqpb.png",
      applicationDate: "2024-10-01",
      requestedDuration: "15 Days",
      requestedRoute: "Lagos - Port Harcourt",
      status: "Document Verification",
      progress: 30,
      nextStep: "Owner Review",
      estimatedCompletion: "2024-10-08"
    },
    {
      id: 2,
      vesselName: "Offshore Guardian",
      vesselType: "AHTS 003",
      image: "https://res.cloudinary.com/du44pwjoi/image/upload/v1742471097/csv_klkqpb.png",
      applicationDate: "2024-09-28",
      requestedDuration: "45 Days",
      requestedRoute: "Port Harcourt - Offshore Field",
      status: "Price Negotiation",
      progress: 65,
      nextStep: "Contract Signing",
      estimatedCompletion: "2024-10-05"
    },
    {
      id: 3,
      vesselName: "Coastal Surveyor",
      vesselType: "SEV 002",
      image: "https://res.cloudinary.com/du44pwjoi/image/upload/v1742471097/csv_klkqpb.png",
      applicationDate: "2024-10-02",
      requestedDuration: "10 Days",
      requestedRoute: "Lagos Coastal Survey",
      status: "Initial Review",
      progress: 15,
      nextStep: "Document Verification",
      estimatedCompletion: "2024-10-12"
    }
  ];

  // Function to get status class
  const getStatusClass = (status) => {
    switch(status) {
      case "Document Verification": return "status-verification";
      case "Price Negotiation": return "status-negotiation";
      case "Initial Review": return "status-review";
      case "Contract Signing": return "status-contract";
      case "Final Approval": return "status-approval";
      default: return "";
    }
  };

  return (
    <div className="ongoing-process-container">
      <h2 className="process-title">Ongoing Applications ({processes.length})</h2>
      
      <div className="process-list">
        {processes.map(process => (
          <div className="process-card" key={process.id}>
            <div className="process-header">
              <div className="process-image">
                <img src={process.image} alt={process.vesselName} />
              </div>
              <div className="process-vessel-info">
                <h3>{process.vesselName}</h3>
                <span className="vessel-type">{process.vesselType}</span>
              </div>
              <div className={`process-status ${getStatusClass(process.status)}`}>
                {process.status}
              </div>
            </div>
            
            <div className="process-progress">
              <div className="progress-bar">
                <div 
                  className="progress-fill" 
                  style={{ width: `${process.progress}%` }}
                ></div>
              </div>
              <div className="progress-text">{process.progress}% Complete</div>
            </div>
            
            <div className="process-details">
              <div className="detail-col">
                <div className="detail-item">
                  <span className="detail-label">Application Date:</span>
                  <span className="detail-value">{process.applicationDate}</span>
                </div>
                <div className="detail-item">
                  <span className="detail-label">Duration Requested:</span>
                  <span className="detail-value">{process.requestedDuration}</span>
                </div>
              </div>
              <div className="detail-col">
                <div className="detail-item">
                  <span className="detail-label">Route:</span>
                  <span className="detail-value">{process.requestedRoute}</span>
                </div>
                <div className="detail-item">
                  <span className="detail-label">Next Step:</span>
                  <span className="detail-value highlight">{process.nextStep}</span>
                </div>
              </div>
              <div className="detail-col">
                <div className="detail-item">
                  <span className="detail-label">Est. Completion:</span>
                  <span className="detail-value">{process.estimatedCompletion}</span>
                </div>
              </div>
            </div>
            
            <div className="process-actions">
              <button className="process-action-btn view-details">View Application</button>
              <button className="process-action-btn track-progress">Track Progress</button>
              {process.status === "Price Negotiation" && (
                <button className="process-action-btn negotiate">Continue Negotiation</button>
              )}
              {process.status === "Document Verification" && (
                <button className="process-action-btn upload">Upload Documents</button>
              )}
            </div>
          </div>
        ))}
      </div>
    </div>
  );
} 